//Docs https://support.maestrooo.com/article/304-technical-javascript-events-exposed-by-the-theme
/*document.addEventListener('variant:add', function(event) {
  let items = event.detail.items; // Get items added
  for (let i = 0; i < items.length; i++) {
    const variant = items[i];
    if (variant.id === 47205622612265){
      let formData = {
       'items': [{
        'id': 47213802619177,
        'quantity': 1
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  }
});*/
document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  document.querySelectorAll(".affirm-as-low-as").forEach(el=>el.setAttribute('data-amount',variant.price));
  affirm.ui.refresh();
});


// document.addEventListener('DOMContentLoaded', function () {
//   const videos = document.querySelectorAll('video');
//   videos.forEach(function(video) {
//     video.addEventListener('contextmenu', function(e) {
//       e.preventDefault();
//       return false;
//     });
//     video.addEventListener('mousedown', function(e) {
//       if(e.button === 2) {
//         return false
//       }
//     });
//   });
// });




//文字动画效果
const WeScrollAnimatorText = {
  init(selector) {
    if (!selector) {
      return console.error('Selector is required');
    }

    const elements = document.querySelectorAll(selector);
    if (!elements.length) {
      return console.warn('No elements found for selector:', selector);
    }

    elements.forEach(el => this.createObserver(el));

    document.addEventListener('shopify:section:load', (e) => {
      const newElements = Array.from(e.target.querySelectorAll(selector));
      newElements.forEach(el => this.createObserver(el));
    });
  },
  
  /**
   * 为单个元素创建 IntersectionObserver
   * @param {Element} el - 要监听的 DOM 元素
   */
  createObserver(el) {
    let thresholdValue = el.getAttribute('data-threshold');
    console.log(thresholdValue,"thresholdValue");
    
    let threshold = thresholdValue ? parseFloat(thresholdValue) : 0.2;
    if (isNaN(threshold) || threshold < 0 || threshold > 1) {
        console.warn(`Invalid threshold value for element:`, el, `. Using default 0.2.`);
        threshold = 0.2;
    }
    const observer = new IntersectionObserver(this.handleIntersect, {
      root: null, // 视口
      rootMargin: '0px',
      threshold: threshold 
    });
    observer.observe(el);
  },
  handleIntersect(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }
};


const WeScrollAnimatorList = {
  init(selector, options = {}) {
    const lists = document.querySelectorAll(selector);
    if (!lists.length) return;

    const delayStep = options.delayStep || 200;

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const container = entry.target;
        let items = Array.from(container.querySelectorAll('[role="listitem"]'));

        // 检查容器 flex-direction 是否为 row-reverse
        const style = window.getComputedStyle(container);
        const isRowReverse = style.display.includes('flex') && style.flexDirection === 'row-reverse';

        if (isRowReverse) {
          items = items.reverse();
        }

        items.forEach((item, index) => {
          setTimeout(() => {
            item.classList.add('visible');
          }, index * delayStep);
        });

        observer.unobserve(container);
      });
    }, {
      threshold: 0.2
    });

    // 监听 Section 加载（适用于主题编辑器）
    document.addEventListener('shopify:section:load',  (e) =>  {
      const listAll = e.target.querySelectorAll('.we-animate__list')
      listAll.forEach(list => observer.observe(list))
    });
    lists.forEach(list => observer.observe(list));
  }
};


window.addEventListener('DOMContentLoaded',()=>{
  WeScrollAnimatorText.init('.we-animate__text');
  WeScrollAnimatorList.init('.we-animate__list');
})



// 下拉组件
window.customElements.get("we-select") || window.customElements.define("we-select",class extends HTMLElement{
    constructor() {
        super();
        this._initSelect = this._initSelect.bind(this);
        this._handleInputClick = this._handleInputClick.bind(this);
        this._handleDocumentClick = this._handleDocumentClick.bind(this);
        this._handleScroll = this._handleScroll.bind(this);
        this._globalListenersAdded = false;
    }

    connectedCallback() {
        this.option = JSON.parse(this.getAttribute('option'));
        this.currentValue = this.getAttribute('default-value') || this.option[0].value;
        this.attachShadow({ mode: 'open' });
        this.currentIndex = this.option.findIndex(item => item.value == this.currentValue);
        this.selectId = this.generateSimpleId();
        this._initSelect();
    }

    disconnectedCallback() {
        window.removeEventListener('scroll', this._handleScroll);
        document.removeEventListener('click', this._handleDocumentClick);
        document.removeEventListener('resize', this._handleScroll);
        if (this.optionsWrapper) {
            this.optionsWrapper.remove();
        }
    }
    
    _handleScroll() {
        if (this.optionsWrapper) {
            this.optionsWrapper.classList.remove('active');
        }
    }

    _handleDocumentClick(e) {
        const clickedElement = e.target;
        const isClickInsideComponent = this.contains(clickedElement);
        if (!isClickInsideComponent) {
            if (this.optionsWrapper) {
                this.optionsWrapper.classList.remove('active');
            }
        }
    }

    _initSelect() {
        this.shadowRoot.innerHTML = `
            <style>
              /* 你的组件内部样式 */
            </style>
            <div class="we-select" part="we-select">
                <div class="we-select__input__wrapper" part="we-select__input__wrapper">
                    <div class="we-select__input" part="we-select__input">
                        ${this.option[this.currentIndex].label}
                    </div>
                    <svg part="we-select__arrow" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 8.25L12 15.75L19 8.25" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
        `;
        this.selectInput = this.shadowRoot.querySelector('.we-select__input__wrapper');
        this.selectInput.addEventListener('click', this._handleInputClick);
    }
    
    _handleInputClick(e) {
      if (this.optionsWrapper && this.optionsWrapper.classList.contains('active')) {
        this.optionsWrapper.classList.remove('active');
        return;
      }
      
      if (!this.optionsWrapper) {
        const optionsWrapper = document.createElement('div');
        optionsWrapper.classList.add(`we-select-options-${this.selectId}`, 'we-select-options');
        // ...创建下拉框内容...
        optionsWrapper.innerHTML = `
            <div class="we-select__options__wrapper">
              <div class="we-select__options">
                ${
                  this.option.map(item => {
                      if (item.labelText) {
                          return `<div class="we-select__options__item__label">${item.labelText}</div>`;
                      } else {
                          return `<div class="we-select__options__item" value="${item.value}">${item.label}</div>`;
                      }
                  }).join('')
                }
              </div>
            </div>
        `;
        document.body.appendChild(optionsWrapper);
        this.optionsWrapper = optionsWrapper;
        this.optionsWrapper.addEventListener('wheel', this._handleOptionsWheel);
        const selectOptionsItem = this.optionsWrapper.querySelectorAll('.we-select__options__item');
        Array.from(selectOptionsItem).forEach(item => {
            item.addEventListener('click', this._changeSelect.bind(this));
        });

        if (!this._globalListenersAdded) {
          window.addEventListener('scroll', this._handleScroll);
          window.addEventListener('resize', this._handleScroll);
          document.addEventListener('click', this._handleDocumentClick);
          this._globalListenersAdded = true;
        }
      }
     
      // if (this.optionsWrapper.querySelector('.we-select__options__wrapper .we-select__options')) {
      //   this.optionsScrollWrapper.scrollTop = 0;
      // }

      const selectInputPosition = this.getElementViewportPosition(this.selectInput);
      this.optionsWrapper.style.setProperty('--left', `${selectInputPosition.left}px`);
      this.optionsWrapper.style.setProperty('--top', `${selectInputPosition.bottom}px`);
      this.optionsWrapper.style.setProperty('--width', `${selectInputPosition.width}px`);
      this.optionsWrapper.classList.add('active');

      this.optionsWrapper.querySelector('.we-select__options__wrapper').scrollTop = 0;
    }

    _handleOptionsWheel(e) {
      e.stopPropagation();
    }

    /**
     * 获取元素位置
     */
    getElementViewportPosition(element) {
      if (!element) {
        return null;
      }
      const rect = element.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const bottomToViewport = viewportHeight - rect.bottom;
      return {
        left: rect.left,
        bottom: rect.bottom,
        bottomToViewport: bottomToViewport,
        width: rect.width,
        height: rect.height,
      };
    }

    /**
     * 生成唯一ID
     */
    generateSimpleId() {
      return Math.random().toString(36).substring(2, 9) + Date.now().toString(36);
    }

    _changeSelect(e){
      const value = e.target.getAttribute('value')
      if (this.currentValue === value) return
      this.shadowRoot.querySelector('.we-select__input').innerText = this.option.find(item => item.value == value).label
      this.currentValue = value                
      this.dispatchEvent(new CustomEvent('change', {
          detail: {
              value: value
          }
      }))
    }
})

// 自定义affirm显示
window.customElements.get('we-affirm') ||
  window.customElements.define('we-affirm', class extends HTMLElement {
    connectedCallback() {
      const price = parseFloat(this.getAttribute('price')); // price 单位：美分
      if (isNaN(price)) {
        this.innerText = '';
        return;
      }

      const { months, apr } = this.getMaxInstallment(price);
      const monthly = this.calcMonthly(price / 100, months, apr); // 转成美元计算
      this.innerText = `or $${monthly}/mo. for ${months} months`;
    }

    // 最大分期规则（单位：美分）
    getMaxInstallment(price) {
      if (price <= 69999) {
        return { months: 12, apr: 15.00 };
      } else if (price <= 169999) {
        return { months: 18, apr: 14.99 };
      } else {
        return { months: 36, apr: 14.99 };
      }
    }

    // 等额本息公式（向上取整）
    calcMonthly(price, months, apr) {
      if (apr === 0) {
        return Math.ceil(price / months);
      }
      const monthlyRate = apr / 12 / 100;
      const payment = price * (monthlyRate * Math.pow(1 + monthlyRate, months)) /
        (Math.pow(1 + monthlyRate, months) - 1);
      return Math.ceil(payment);
    }
  });